// Alira header scroll behaviour — reserved for future enhancements

// ---------------------------------------------------------------------------
// Galerij kleurfilter (14-09-2026)
//
// Shopify koppelt per variant maar een foto, de front. In de productgalerij
// draagt daardoor alleen die ene foto een data-variant-ids. De filter in
// sections/alira-product.liquid laat foto's zonder variant-ids altijd staan,
// dus bij een product met twaalf kleuren bleven alle 84 foto's zichtbaar.
//
// Hieronder vullen we data-variant-ids aan op elke galerijfoto, afgeleid uit
// de alt-tekst, en laten we de bestaande filter daarna gewoon zijn werk doen.
// Daarnaast blijft pijltjes- en veegnavigatie binnen de gekozen kleur.
//
// Veilig van opzet: herkent het script niet elke foto, dan verandert het
// niets en blijft de galerij zich gedragen zoals voorheen.
// ---------------------------------------------------------------------------
(function(){
  if(!/^\/products\//.test(window.location.pathname)) return;

  function norm(s){ return (s||'').toLowerCase().replace(/[^a-z0-9]+/g,''); }

  var thumbs = [], bezig = false;

  function kleurVan(el, namen){
    var img = el.querySelector('img');
    var alt = norm(img ? (img.alt || '') : '');
    if(!alt) return null;
    for(var i=0;i<namen.length;i++){
      var n = norm(namen[i]);
      if(n && alt.indexOf(n) !== -1) return namen[i];
    }
    return null;
  }

  function zichtbare(){
    return thumbs.filter(function(t){ return !t.classList.contains('is-hidden'); });
  }

  // Loopt de bezoeker buiten zijn kleur, dan terugzetten via een klik op de
  // thumbnail, zodat de galerij zelf zijn interne positie bijwerkt.
  function bewaak(){
    if(bezig) return;
    var actief = document.querySelector('.ap-gallery__thumb.is-active');
    if(!actief || !actief.classList.contains('is-hidden')) return;
    var zicht = zichtbare();
    if(!zicht.length) return;
    var ai = thumbs.indexOf(actief);
    var eerste = thumbs.indexOf(zicht[0]);
    var laatste = thumbs.indexOf(zicht[zicht.length-1]);
    var doel = null;
    if(ai > laatste){ doel = zicht[0]; }
    else if(ai < eerste){ doel = zicht[zicht.length-1]; }
    else {
      var bd = Infinity;
      zicht.forEach(function(t){
        var d = Math.abs(thumbs.indexOf(t) - ai);
        if(d < bd){ bd = d; doel = t; }
      });
    }
    if(!doel) return;
    bezig = true;
    doel.click();
    setTimeout(function(){ bezig = false; }, 60);
  }

  function pasToe(product){
    var track = document.getElementById('ap-slides');
    if(!track) return;

    var kleuren = {};
    (product.variants || []).forEach(function(v){
      var k = v.option1;
      if(k === null || k === undefined) return;
      (kleuren[k] = kleuren[k] || []).push(String(v.id));
    });
    var namen = Object.keys(kleuren).sort(function(a,b){
      return norm(b).length - norm(a).length;
    });
    if(namen.length < 2) return;

    // Korte optiewaarden zijn geen kleurnamen maar maten (XS, S, M, L). Die
    // zouden per ongeluk in de productnaam gevonden worden, dus die slaan we
    // over. Bij Emberly is maat de eerste optie, dat product blijft zo ongemoeid.
    for(var n0=0; n0<namen.length; n0++){
      if(norm(namen[n0]).length < 3) return;
    }

    var els = [].slice.call(document.querySelectorAll('.ap-gallery__slide, .ap-gallery__thumb'));
    if(!els.length) return;

    // Eerst alleen kijken, pas aanpassen als het plaatje helemaal klopt.
    var gevonden = {}, raak = 0;
    var perEl = els.map(function(el){
      var k = kleurVan(el, namen);
      if(k){ gevonden[k] = true; raak++; }
      return k;
    });

    // Elke foto moet bij een kleur horen en elke kleur moet foto's hebben.
    if(raak !== els.length) return;
    if(Object.keys(gevonden).length !== namen.length) return;

    els.forEach(function(el, i){
      el.setAttribute('data-variant-ids', kleuren[perEl[i]].join(','));
    });

    thumbs = [].slice.call(document.querySelectorAll('.ap-gallery__thumb'));

    // Het filteren doen we zelf. De galerij heeft er wel een functie voor, maar
    // die laat in de praktijk alles staan, en zo zijn we er niet van afhankelijk.
    var kleurVanThumb = thumbs.map(function(t){ return kleurVan(t, namen); });

    function filter(kleur){
      if(!kleur) return;
      thumbs.forEach(function(t, i){
        t.classList.toggle('is-hidden', kleurVanThumb[i] !== kleur);
      });
    }

    function huidigeKleur(){
      var a = document.querySelector('.ap-swatch.is-active');
      if(!a) return null;
      return a.getAttribute('data-color') || a.getAttribute('title');
    }

    // Na de eigen afhandeling van de galerij opnieuw filteren. Via delegatie op
    // document, zodat het ook blijft werken als de swatches opnieuw opgebouwd
    // worden, en met een setTimeout zodat de galerij eerst zijn gang kan gaan.
    var herstellen = false;
    function herfilter(){
      if(herstellen) return;
      herstellen = true;
      filter(huidigeKleur());
      setTimeout(function(){ herstellen = false; }, 0);
    }

    document.addEventListener('click', function(e){
      var el = e.target;
      while(el && el !== document){
        if(el.classList && el.classList.contains('ap-swatch')){
          setTimeout(herfilter, 0);
          return;
        }
        el = el.parentNode;
      }
    }, true);

    // Zet de galerij de thumbnails alsnog allemaal terug, dan corrigeren we dat.
    var balk = document.querySelector('.ap-gallery__thumbs');
    if(balk && window.MutationObserver){
      new MutationObserver(herfilter).observe(balk, {
        subtree: true, attributes: true, attributeFilter: ['class']
      });
    }

    filter(huidigeKleur());

    if(window.MutationObserver){
      new MutationObserver(bewaak).observe(track, { attributes: true, attributeFilter: ['style'] });
    }
  }

  function start(){
    var pogingen = 0;
    (function wacht(){
      if(document.getElementById('ap-slides') && document.querySelector('.ap-swatch.is-active')){
        fetch(window.location.pathname.split('?')[0] + '.js', { credentials: 'same-origin' })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(p){ if(p) pasToe(p); })
          .catch(function(){});
        return;
      }
      if(++pogingen < 40) setTimeout(wacht, 100);
    })();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
